import { Casier } from "./Casier";
import { ModeleDeBase } from "./ModeleDeBase";

export interface IPavillonCDS {
  si_codeimmeuble?: string;
  si_sigleetnomdelimmeuble?: string;
  si_sigleimmeuble: string;
  si_immeublesiid: string;
  createdon?: string;
  si_nomimmeuble: string;
  si_surcampus?: boolean;
  si_CasierSI_si_ImmeubleSI_si_ImmeubleSI?: Casier[];
}

export class Pavillon extends ModeleDeBase {
  nomPavillon: string;
  sigle: string;
  nombreCasiersDispos: number = 0;

  constructor(entity: IPavillonCDS) {
    super(entity.si_immeublesiid);

    if (entity.si_CasierSI_si_ImmeubleSI_si_ImmeubleSI !== undefined) {
      this.nombreCasiersDispos =
        entity.si_CasierSI_si_ImmeubleSI_si_ImmeubleSI.length;
    }
    this.nomPavillon = entity.si_nomimmeuble;
    this.sigle = entity.si_sigleimmeuble;
  }

  serialiser(): IPavillonCDS {
    return {
      si_immeublesiid: this.id,
      si_nomimmeuble: this.nomPavillon,
      si_sigleimmeuble: this.sigle,
    };
  }
}
